// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".textHighlighted_3-SDD{font-weight:700;color:#ec853c}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"textHighlighted": "textHighlighted_3-SDD"
};
module.exports = ___CSS_LOADER_EXPORT___;
